import * as React from "react"
import {Box, IconButton, InputAdornment, Tooltip} from "@mui/material";
import {AutocompleteAjaxSeeker, IconSeeker} from "@ui-seeker/core";

import {BACKEND_APIS} from "@constants";
import {useComputed} from "@preact/signals-react";
import {matcherSKUDrawerData} from "../../../@signals";


export default function LineSelector({ value, onChange, disabled, error, filters, onCreateClick, canCreate }) {
	const brandID = useComputed(() => matcherSKUDrawerData.value.brandID)

	return <AutocompleteAjaxSeeker
		urlAjax={`${BACKEND_APIS.MATCHERS}/selectors/line-options${brandID.value ? `/${brandID}` : ''}`}
		filters={filters}
		label="Line"
		placeholder="Please select a line"
		value={value || ''}
		onChange={onChange}
		disabled={disabled}
		error={error}
		inputProps={{
			endAdornment: (
				<InputAdornment position="end">
					<Tooltip title="Create New Line">
						<Box component="span">
							<IconButton
								size="small"
								onClick={canCreate ? onCreateClick : undefined}
								disabled={!canCreate}
								sx={{ 
									color: canCreate ? 'primary.main' : 'disabled.main',
									'&:hover': canCreate ? { color: 'primary.dark' } : {}
								}}
							>
								<IconSeeker icon="octagon-plus" sx={{ fontSize: '1.25rem' }} />
							</IconButton>
						</Box>
					</Tooltip>
				</InputAdornment>
			)
		}}
	/>
}
